<template>
  <ResizablePage>
    <template v-slot:content="conentProps">
      <v-data-table
        :headers="headers"
        :items="vehicles"
        :items-per-page="-1"
        :height="conentProps.tableHeight"
        tableProps.tableHeight
        fixed-header
        hide-default-footer
        :search="fastFilter"
        :item-class="rowStyle"
        @click:row="rowClick"
        @contextmenu:row="rowMenuClick"
      >
      </v-data-table>

      <v-menu
        v-model="contextMenu"
        :position-x="contextMenuX"
        :position-y="contextMenuY"
        absolute
        offset-y
      >
        <v-list>
          <template v-for="(item, index) in contextItems">
            <v-divider class="mx-3" :key="index" v-if="item.topBorder" />
            <v-list-item v-if="item.enabled"
                         :key="index"
                         link
                         @click="rowMenuItemClick(item)"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
    </template>
  </ResizablePage>
</template>

<script>
import ResizablePage from "@/components/ResizablePage";
import utils from "@/utils";
import { DateTime } from "luxon";

export default {
  name: "VehiclesView",
  components: { ResizablePage },

  data() {
    return {
      mounted: false,
      contextMenu: false,
      contextMenuX: 0,
      contextMenuY: 0,
      contextVehicle: null,
      contextItems: [
        { name: "map", title: this.$t("table.vehicles.context-menu.map"), enabled: true },
        { name: "history", title: this.$t("table.vehicles.context-menu.history"), enabled: true },
        { name: "logbook", title: this.$t("table.vehicles.context-menu.logbook"), enabled: true },
        {
          name: "report-logbook",
          title: this.$t("table.vehicles.context-menu.report-logbook"),
          enabled: true,
          topBorder: true
        },
        { name: "report-performance", title: this.$t("table.vehicles.context-menu.report-performance"), enabled: true },
        { name: "report-machine-performance", title: this.$t("table.vehicles.context-menu.report-machine-performance"), enabled: true }
      ],
      headers: [
        {
          text: this.$t("table.vehicles.header.numeric_plate"),
          align: "start",
          sortable: true,
          width: "11%",
          value: "numericPlate"
        },
        {
          text: this.$t("table.vehicles.header.name"),
          align: "start",
          sortable: true,
          width: "11%",
          value: "name"
        },
        {
          text: this.$t("table.vehicles.header.type"),
          align: "start",
          sortable: true,
          width: "15%",
          value: "typeCode"
        },
        {
          text: this.$t("table.vehicles.header.imei"),
          align: "start",
          sortable: true,
          width: "11%",
          value: "imei"
        },
        {
          text: this.$t("table.vehicles.header.installDate"),
          align: "start",
          sortable: true,
          width: "12%",
          value: "installDate"
        },
        {
          text: this.$t("table.vehicles.header.state"),
          align: "start",
          value: "state",
          sort: (a, b) => {
            return this.sortState(a, b);
          }
        }
      ]
    };
  },

  computed: {
    fastFilter: function() {
      return this.$store.state.data.fastFilter;
    },
    vehicles: function() {
      if (this.$store.state.data.records === null || this.$store.state.data.module !== "vehicle")
        return [];
      else
        return this.$store.state.data.records.map(x => {
          return {
            vehicleId: x.vehicleId,
            vehicleState: x.state,
            code: x.typeCode,
            numericPlate: x.numericPlate,
            name: x.name,
            typeCode: this.$t("enum.vehicle_type." + x.typeCode),
            imei: (x.device != null) ? x.device.serialNumber : "",
            installDate: (x.device != null) ? DateTime.fromISO(x.device.installDate).toLocaleString(DateTime.DATE_SHORT) : "",
            state: this.getState(x)
          };
        });
    }
  },

  methods: {
    getState(vehicle) {
      let state = utils.vehicleState(vehicle);

      if (state === "NEW")
        return this.$t("common.vehicle.state_fail");
      else {
        let result = (state === "ACTIVE") ? this.$t("common.vehicle.state_ok") : this.$t("common.vehicle.state_fail");

        return result + " - "
          + DateTime.fromISO(vehicle.location.timestamp).toLocaleString(DateTime.DATETIME_SHORT) + " ("
          + DateTime.fromISO(vehicle.location.timestamp).toRelative() + ")";
      }
    },

    sortState(a, b) {
      if (a === null)
        return (b === null) ? 0 : 1;
      else if (b === null)
        return -1;
      else
        return DateTime.fromISO(a.timestamp).diff(b.timestamp, "seconds");
    },

    rowClick(item) {
      this.$router.push({ name: "data/vehicle", params: { id: item.vehicleId } });
    },

    rowMenuClick(event, item) {
      this.contextItems.find(x => x.name === "report-performance").enabled = item.item.code !== "machine";
      this.contextItems.find(x => x.name === "report-machine-performance").enabled = item.item.code === "machine";

      this.contextMenuX = event.clientX;
      this.contextMenuY = event.clientY;
      this.contextMenu = true;
      this.contextVehicle = item.item;

      event.preventDefault();
    },

    rowMenuItemClick(item) {
      switch (item.name) {
        case "map":
          this.$router.push({
            name: "map/vehicle",
            params: { ccode: this.$store.state.auth.company.code, id: this.contextVehicle.vehicleId }
          });
          break;
        case "history":
          this.$router.push({
            name: "map/history",
            params: { ccode: this.$store.state.auth.company.code, id: this.contextVehicle.vehicleId }
          });
          break;
        case "logbook":
          this.$router.push({
            name: "map/logbook",
            params: { ccode: this.$store.state.auth.company.code, id: this.contextVehicle.vehicleId }
          });
          break;
        case "report-logbook":
          this.$router.push({
            name: "report/logbook",
            params: { ccode: this.$store.state.auth.company.code },
            query: { "vehicleId": this.contextVehicle.vehicleId, "periodName": "month-current" }
          });
          break;
        case "report-performance":
          this.$router.push({
            name: "report/performance",
            params: { ccode: this.$store.state.auth.company.code },
            query: { "vehicleId": this.contextVehicle.vehicleId, "periodName": "month-current" }
          });
          break;
        case "report-machine-performance":
          this.$router.push({
            name: "report/machine-performance",
            params: { ccode: this.$store.state.auth.company.code },
            query: { "vehicleId": this.contextVehicle.vehicleId, "periodName": "month-current" }
          });
          break;
      }
    },

    rowStyle: function(item) {
      if (item.vehicleState === "hidden")
        return "table-row-hidden";
      else if (item.vehicleState === "removed")
        return "table-row-removed";
      else
        return "";
    }
  },

  watch: {
    "$store.state.auth.company": function() {
      if (this.mounted)
        this.$store.dispatch("data/fetchRecords", { module: "vehicle" });
    }
  },
  mounted() {
    this.mounted = true;
    this.$store.dispatch("data/fetchRecords", { module: "vehicle" });
  },
  destroyed() {
    this.mounted = false;
  }
};
</script>

<style lang="sass" scoped>
</style>